const COLOR_CLASSES: Record<string, string> = {
  blue:   'bg-blue-100 text-blue-800',
  cyan:   'bg-cyan-100 text-cyan-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  orange: 'bg-orange-100 text-orange-800',
  purple: 'bg-purple-100 text-purple-800',
  indigo: 'bg-indigo-100 text-indigo-800',
  red:    'bg-red-100 text-red-800',
  green:  'bg-green-100 text-green-800',
  teal:   'bg-teal-100 text-teal-800',
  gray:   'bg-gray-100 text-gray-600',
};

interface GenericStateBadgeProps {
  value: string;
  statesMap: Record<string, { label: string; color: string }>;
  small?: boolean;
}

export default function GenericStateBadge({ value, statesMap, small }: GenericStateBadgeProps) {
  const info = statesMap[value];
  if (!info) return <span className="text-gray-500 text-xs">{value}</span>;

  const colorClass = COLOR_CLASSES[info.color] ?? 'bg-gray-100 text-gray-800';
  const sizeClass = small ? 'px-1.5 py-0.5 text-[10px]' : 'px-2.5 py-0.5 text-xs';

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${sizeClass} ${colorClass}`}>
      {info.label}
    </span>
  );
}
